<template lang="pug">
.subscribe-modal
  edit-member-modal(v-if="openEditMemberDialog" :open.sync="openEditMemberDialog" :company="company" :count="totalAllowedMember")
  edit-form-modal(v-if="openEditFormDialog" :open.sync="openEditFormDialog" :company="company" :count="totalAllowedForm")
  y-dialog(v-model="dialog" :max-width="(step == 1 || step == 2)? '600px' : '400px'" persistent scrollable)
    v-card
      v-card-title.px-4
        span {{ windowTitle }}
        v-spacer
        v-progress-circular(:value="currentProgress" size='24' color="primary")
      v-divider
      v-card-text.px-4
        v-window(v-model="step")
          v-window-item(:value="0")
            v-container(v-if="authMember.id === company.primary_owner")
              div
                p If you subscribe now, you can enjoy
                  b  70% Subsidy
                  span  for
                  b  12 months
                  span  sponsored by
                  b  Malaysian Government initiative for SMEs and B40s
                p *Discount is offered for a limited time or until quota is reached. Quota for
                  b.mx-1 personal plan
                  span is
                  b.mx-1 no longer available.
            v-container(v-else)
              p Please contact your admin and notify them to renew subscription.

          v-window-item(:value="1")
            div.mt-4.font-weight-bold Your current account
            v-card
              v-simple-table.mt-4
                template(v-slot:default)
                  tbody
                    tr
                      td.font-weight-bold(:class="isValidMemberCount ? '' : 'red--text' ") {{ company.active_member_count }} active salespersons/agents
                      td.text-right
                        v-btn(v-if="!isValidMemberCount" icon @click="openEditMemberDialog = true")
                          v-icon mdi-square-edit-outline
                        v-icon.mr-2(v-else color="green lighten-1" @click="openEditMemberDialog = true") mdi-check-circle
                    tr
                      td.font-weight-bold(:class="isValidFormCount ? '' : 'red--text' ") {{ company.published_form_count }} published forms
                      td.text-right
                        v-btn(v-if="!isValidFormCount" icon @click="openEditFormDialog = true")
                          v-icon mdi-square-edit-outline
                        v-icon.mr-2(v-else color="green lighten-1" @click="openEditFormDialog = true") mdi-check-circle

            div.mt-6.title.font-weight-bold.black--text.text-center Suitable plan for you
            h1.display-2.text-center.font-weight-bold {{ totalPrice }}
              span(v-if="extraPrice")  + {{ extraPrice }}
            h3.subtitle.text-center(v-if="totalPrice != 37") Normal Price:
              span(style="text-decoration: line-through;") RM {{ totalPriceNormal }}
              span(v-if="extraPrice")  + {{ extraPrice }}
            div.caption.text-center.font-medium RM per month with {{ form.commitment }} contract
            div.mt-4.mb-2.font-weight-bold.text-center Change plan
            v-card.px-2.mb-4(outlined)
              v-list
                template(v-for="(plan, index) in plans")
                  v-list-item.px-0
                    v-list-item-content
                      v-row(align="center")
                        v-col.py-0.pr-0
                          p.mb-0.font-weight-bold.mr-2.d-inline(style="font-size: 16px") {{ plan.name }}
                          v-chip.py-1.px-2.d-inline(color="primary" small outlined) RM{{ plan.price[form.commitment] }}/month
                        v-col.py-0.shrink
                          v-btn(v-if="plan.selected" small color="primary" depressed width="60")
                            v-icon mdi-check
                          v-btn(v-else outlined small color="primary" width="60" @click="selectPlan(plan)") Select
                      v-list-item-subtitle {{ plan.detail }}
                      v-list-item-subtitle.mt-1.caption.font-weight-bold(v-if="plan.name == 'Personal'") {{ plan.note }}

            div.mb-2.font-weight-bold.text-center Add-ons
            v-card.pa-2.mb-4(outlined)
              v-list-item.px-0.my-n2(v-if="formItems.length > 0")
                v-list-item-content
                  v-list-item-title.font-weight-bold Form
                  v-list-item-subtitle + RM3 each
                v-list-item-action
                  div(style="width: 80px;")
                    v-select(v-model="formAddOnCount" hide-details outlined dense :items="formItems")
              v-list-item.px-0.my-n2
                v-list-item-content
                  v-list-item-title.font-weight-bold Salesperson
                  v-list-item-subtitle + RM10 each
                v-list-item-action
                  div(v-if="memberItems.length > 0" style="width: 80px;")
                    v-select(v-model="memberAddOnCount" hide-details outlined dense :items="memberItems")
                  v-layout(v-else)
                    v-btn.my-auto(icon small @click="memberAddOnCount--" :disabled="memberAddOnCount < 1")
                      v-icon(color="primary") mdi-minus-circle
                    span.my-auto.text-center.colbox {{ memberAddOnCount }}
                    v-btn.my-auto(icon small @click="memberAddOnCount++")
                      v-icon(color="primary") mdi-plus-circle

          v-window-item(:value="2")
            //- v-select.mx-4.mt-6.mb-n3(v-model='accountType' label="Account type" :items="accountTypes" item-text="name" item-value="id" outlined)
            validate-project-sme(v-if="accountType == 'business'" @verified="handleVerification" :proceed.sync="proceed" :company="company")
            validate-project-b40(v-if="accountType == 'personal'" @verified="handleVerification" :proceed.sync="proceed" :company="company")
          v-window-item(:value="3")
            card-list.mt-4(@change="form.card = $event.id")
          v-window-item.text-center(:value="4")
            div.mt-6.title.font-weight-bold.black--text {{ selectedPlan.name }} Plan
            h1.display-2.text-center.font-weight-bold {{ totalPrice }}
              span(v-if="extraPrice") + {{ extraPrice }}
            div.caption.text-center.font-medium RM per month with {{ form.commitment }} contract
            .extra.mt-2(v-if="formAddOnCount || memberAddOnCount")
              div.black--text Included:
              div.body-2(v-if="formAddOnCount") {{ formAddOnCount }} extra form(s)
              div.body-2(v-if="memberAddOnCount") {{ memberAddOnCount }} extra member(s)
          v-window-item(:value="5")
            v-container
              div Thank you for giving us the opportunity to help you grow further and bigger. Let’s do this together.
      v-divider
      v-card-actions(v-if="authMember.id === company.primary_owner")
        v-spacer
        template(v-if="step === 0")
          v-btn(v-if="skippable" text @click="dialog = false") Subscribe later
        v-btn(v-else-if="step !== 5" text @click="backStep") Back
        v-btn(v-if="step === 3" color="accent" @click="nextStep" depressed :disabled="!form.card") Next
        v-btn(v-else-if="step === 4" @click="nextStep" color="accent" depressed :loading="isLoading") Confirm
        v-btn(v-else-if="step === 5" @click="finish()" color="accent" depressed) Finish
        v-btn(v-else color="accent" @click="nextStep" depressed) Next

</template>

<script>
import { mapActions } from 'vuex'
import { setOptions, bootstrap } from 'vue-gtag'
import CardList from '@/components/billing/CardList.vue'
import SubscribeLaterModal from './SubscribeLaterModal'
import EditMemberModal from './EditMemberModal'
import EditFormModal from './EditFormModal'
import ValidateProjectB40 from '@/views/signup/components/ValidateProjectB40'
import ValidateProjectSme from '@/views/signup/components/ValidateProjectSme'

export default {
  name: "Subscribe70Modal",
  components: { SubscribeLaterModal, CardList, EditMemberModal, EditFormModal, ValidateProjectB40, ValidateProjectSme },
  props: ['open', 'company', 'skippable'],
  data: (v) => ({
    accountType: 'personal',
    subscribeLater: false,
    openEditMemberDialog: false,
    openEditFormDialog: false,
    step: 0,
    proceed: 0,
    steps: [
      { title: '70% Subsidy'},
      { title: 'Choose your plan'},
      { title: 'Application form'},
      { title: 'Add Payment Card'},
      { title: 'Confirm your subscription'},
      { title: 'Thank you'}
    ],
    plansB40: [
      { name: 'Personal', value: 1, detail: '1 forms, 1 salesperson', note: '(70% subsidy not available, quota exceeded)',  form_count: 1, member_count: 1, price: { yearly: 37, monthly: 37 }, max: { member: 4, form: 4 }, selected: false, extraInfoRequired: false },
      { name: 'Business', value: 9, detail: '10 forms, 5 salesperson', form_count: 10, member_count: 5, price: { yearly: 44, monthly: 147 }, max: { member: 9, form: 14 }, selected: false, extraInfoRequired: true },
      { name: 'Intelligence', value: 10, detail: 'Unlimited forms, 10 salesperson', form_count: 0, member_count: 10, price: { yearly: 89, monthly: 297 }, max: { member: null, form: null }, selected: false, extraInfoRequired: true }
    ],
    plansSme: [
      { name: 'Personal', value: 1, detail: '1 forms, 1 salesperson', note:  '(subsidy no longer available, quota exceeded)', form_count: 1, member_count: 1, price: { yearly: 37, monthly: 37 }, max: { member: 4, form: 4 }, selected: false, extraInfoRequired: false },
      { name: 'Business', value: 6, detail: '10 forms, 5 salesperson', form_count: 10, member_count: 5, price: { yearly: 44, monthly: 147 }, max: { member: 9, form: 14 }, selected: false, extraInfoRequired: true },
      { name: 'Intelligence', value: 7, detail: 'Unlimited forms, 10 salesperson', form_count: 0, member_count: 10, price: { yearly: 89, monthly: 297 }, max: { member: null, form: null }, selected: false, extraInfoRequired: true }
    ],
    selectedPlan: null,
    form: {
      company: v.company.id,
      plan: null,
      commitment: 'yearly',
      card: null
    },
    accountTypes: [
        {
        name: 'Please Select',
        id: 'select'
      },
      {
        name: 'Company',
        id: 'business'
      },
     {
        name: 'Individual',
        id: 'personal'
      }
    ],
    formAddOnCount: 0,
    memberAddOnCount: 0,
    isLoading: false
  }),
  watch: {
    accountType () {
      this.plans.forEach(p => {
        if (p.name === this.selectedPlan.name) {
          p.selected = true
          this.selectedPlan = p
        } else {
          p.selected = false
        }
      })
    }
  },
  computed: {
    authMember () {
      return this.$store.state.user.member
    },
    dialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    plans () {
      if (this.accountType === 'business') {
        return this.plansSme
      }
      return this.plansB40
    },
    totalAllowedMember () {
      return this.selectedPlan.member_count + this.memberAddOnCount
    },
    isValidMemberCount () {
      if (this.company.active_member_count > this.totalAllowedMember) {
        return false
      }
      return true
    },
    totalAllowedForm () {
      return this.selectedPlan.form_count + this.formAddOnCount
    },
    isValidFormCount () {
      if (this.selectedPlan.name == 'Intelligence') {
        return true
      }
      if (this.company.published_form_count > this.totalAllowedForm) {
        return false
      }
      return true
    },
    extraPrice () {
      let totalPrice = 0
      if (this.formAddOnCount) {
        totalPrice += this.formAddOnCount * 3
      }
      if (this.memberAddOnCount) {
        totalPrice += this.memberAddOnCount * 10
      }
      return totalPrice
    },
    totalPrice () {
      if (!this.selectedPlan) return 0
      if (this.selectedPlan.value === 4) {
        return 'FREE + 2%'
      }
      let basePrice = this.selectedPlan.price.monthly
      if (this.form.commitment == 'yearly') {
        basePrice = this.selectedPlan.price.yearly
      }
      return basePrice
    },
    totalPriceNormal () {
      if (!this.selectedPlan) return 0
      if (this.selectedPlan.value === 4) {
        return 'FREE + 2%'
      }
      let basePrice = this.selectedPlan.price.monthly
      return basePrice
    },
    totalPriceAmount () {
      if (!this.selectedPlan) return 0
      let totalPrice = this.extraPrice
      if (this.selectedPlan.value !== 4) {
        if (this.form.commitment == 'yearly') {
          totalPrice += this.selectedPlan.price.yearly
        } else {
          totalPrice += this.selectedPlan.price.monthly
        }
      }
      return totalPrice
    },
    formItems () {
      if (!this.selectedPlan) return []
      if (this.selectedPlan.name == 'Personal') {
        return [0,1,2,3]
      } else if (this.selectedPlan.name == 'Business') {
        return [0,1,2,3,4]
      }
      return []
    },
    memberItems () {
      if (!this.selectedPlan) return []
      if (this.selectedPlan.name == 'Personal') {
        return [0,1,2,3]
      } else if (this.selectedPlan.name == 'Business') {
        return [0,1,2,3,4]
      }
      return []
    },
    windowTitle () {
      return this.steps[this.step].title
    },
    currentProgress () {
      return Math.ceil((this.step / this.steps.length) * 100)
    }
  },
  mounted () {
    this.fetchCompany()

    let index = 1
    if (this.company.published_form_count > this.plans[0].max.form) {
      index = 1
    }
    if (this.company.published_form_count > this.plans[1].max.form) {
      index = 2
    }
    if (this.company.active_member_count > this.plans[0].max.member) {
      index = 1
    }
    if (this.company.active_member_count > this.plans[1].max.member) {
      index = 2
    }
    this.plans[index].selected = true
    this.selectedPlan = this.plans[index]
    if (this.company.published_form_count - this.selectedPlan.form_count > 0 && index != 2) {
      this.formAddOnCount = this.company.published_form_count - this.selectedPlan.form_count
    }
    if (this.company.active_member_count - this.selectedPlan.member_count > 0) {
      this.memberAddOnCount = this.company.active_member_count - this.selectedPlan.member_count
    }
  },
  methods: {
    ...mapActions([
      'showMessage',
      'updateCompany'
    ]),
    selectPlan(plan) {
      this.plans.forEach(p => {
        if (p.name === plan.name) {
          p.selected = true
          this.selectedPlan = p
          if (this.selectedPlan.name == 'Intelligence') {
            this.formAddOnCount = 0
          } else if (this.formAddOnCount > (this.selectedPlan.max.form - this.selectedPlan.form_count)) {
            this.formAddOnCount = this.selectedPlan.max.form - this.selectedPlan.form_count
          }
          if (this.selectedPlan.name != 'Intelligence' && this.memberAddOnCount > (this.selectedPlan.max.member - this.selectedPlan.member_count)) {
            this.memberAddOnCount = this.selectedPlan.max.member - this.selectedPlan.member_count
          }
        } else {
          p.selected = false
        }
      })
    },
    handleVerification() {
      this.step++
    },
    backStep () {
      if (this.step === 3 && !this.selectedPlan.extraInfoRequired) {
        this.step = 1
      } else {
        this.step--
      }
    },
    nextStep () {
      if (this.step === 1) {
        if (!this.isValidMemberCount) {
          this.showMessage(['error', this.$t('error_message.exceeded_member_count')])
          return
        }
        if (!this.isValidFormCount) {
          this.showMessage(['error', this.$t('error_message.exceeded_form_count')])
          return
        }
        // if (this.selectedPlan.name === 'Personal') {
        //   this.accountType = 'personal'
        // } else {
        //   this.accountType = 'business'
        // }

        if (!this.selectedPlan.extraInfoRequired) {
          this.step = 3
          return
        }
      }
      if (this.step === this.steps.length - 1) return
      if (this.step === 2) {
        this.proceed++
      } else if (this.step === 4) {
        this.form.plan = this.selectedPlan.value
        this.isLoading = true
        this.form.extra_form = this.formAddOnCount
        this.form.extra_member = this.memberAddOnCount
        this.$axios.post(`/billing/contracts/`, this.form)
          .then(() => {
            this.$emit('subscribed')
            this.fetchCompany()
            this.step++
            this.trackGtag()
            this.trackPixel()
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        this.step++
      }
    },
    finish () {
      this.dialog = false
    },
    fetchCompany () {
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        this.$axios.get(`/companies/${this.company.id}/`)
          .then(resp => {
            this.updateCompany(resp.data)
          })
          .catch(() => {})
      } else {
        this.$axios.get(`/companies/${this.$subdomain}/`, { params: { use_slug: 'true' } })
          .then(resp => {
            this.updateCompany(resp.data)
          })
          .catch(() => {})
      }
    },
    trackGtag () {
      setOptions({
        config: { id: process.env.VUE_APP_YEZZA_GTAG_ID }
      })
      bootstrap().then(() => {
        this.$gtag.linker({
          'domains': ['yezza.com', 'yezza.io']
        })
        this.$gtag.purchase({
          'value': this.totalPriceAmount
        })
      })
    },
    trackPixel () {
      window.fbq('trackSingle', process.env.VUE_APP_YEZZA_FB_PIXEL_ID, 'Subscribe', {
        value: this.totalPriceAmount/this.$currency.multiplier,
        currency: this.$currency.code
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.colbox {
  border: 1px solid grey;
  border-radius: 5px;
  text-align: center;
  padding-top: 3px;
  margin-left: 4px;
  margin-right: 4px;
  height: 32px;
  width: 60px;
}
</style>
